export default str => str.replace(/(<([^>]+)>|&nbsp;)/gi, '')
